import service from "./approvedProcessingDraftService";

const approvedProcessingDraftService = [
    ...service
]

export default approvedProcessingDraftService;